import { Form, Modal } from "antd";
import { useCreateOrganization, useUpdateOrganization } from "../hooks/useOrganizations";
import { useOrganizationsStore } from "../store/organizations.store";
import type { CreateOrganizationRequest, UpdateOrganizationRequest } from "../types";
import { OrganizationForm } from "./OrganizationForm";

export function OrganizationFormModal() {
	const [form] = Form.useForm<CreateOrganizationRequest>();
	const { modalOpen, editingItem, closeModal } = useOrganizationsStore();

	const { mutate: create, isPending: isCreating } = useCreateOrganization();
	const { mutate: update, isPending: isUpdating } = useUpdateOrganization();

	const handleClose = () => {
		closeModal();
		form.resetFields();
	};

	const handleSubmit = () => {
		form.validateFields().then((rawValues) => {
			// regionId faqat UI uchun, uni backendga yubormaymiz
			const { regionId, ...values } = rawValues;

			if (editingItem) {
				const updateData: UpdateOrganizationRequest = {};
				for (const key of Object.keys(values) as Array<keyof typeof values>) {
					const newVal = values[key as keyof typeof values];
					const oldVal = editingItem[key as keyof typeof editingItem];
					if (newVal !== oldVal) {
						(updateData as Record<string, unknown>)[key] = newVal;
					}
				}
				update({ id: editingItem.id, data: updateData }, { onSuccess: handleClose });
			} else {
				// Create endpoint expects cleared optional fields to be omitted, not null
				const createData = Object.fromEntries(
					Object.entries(values).filter(([, v]) => v !== null)
				) as unknown as CreateOrganizationRequest;
				create(createData, { onSuccess: handleClose });
			}
		});
	};

	return (
		<Modal
			title={editingItem ? "Tashkilotni tahrirlash" : "Yangi tashkilot"}
			open={modalOpen}
			onCancel={handleClose}
			onOk={handleSubmit}
			confirmLoading={isCreating || isUpdating}
			okText={editingItem ? "Saqlash" : "Yaratish"}
			cancelText="Bekor qilish"
			destroyOnHidden
			width={700}
		>
			<OrganizationForm form={form} />
		</Modal>
	);
}
